
export default {
  props: {
    activeSlide: {
      type: [String, Number],
      required: false,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEnd: false,
      isBeginning: true,
    };
  },
  watch: {
    isBeginning: {
      handler(val) {
        if (val) {
          this.$emit("beginning");
        } else {
          this.$emit("notBeginning");
        }
      },
    },
    isEnd: {
      handler(val) {
        if (val) {
          this.$emit("end");
        } else {
          this.$emit("notEnd");
        }
      },
    },
    activeSlide: {
      handler(val) {
        this.goToSlide(val);
      },
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.mySwiper && !this.$isInEditMode) {
        this.$emit("activeSlide", this.mySwiper.activeIndex);
        // this.swiper.on("slideChange", () => {
        //   this.onSwipe(this);
        // });
      }
    }, 500);
  },
  methods: {
    goToSlide(slide) {
      //   this.activeSlide = slide;
      this.mySwiper.slideTo(slide, 0);
      if (this.mySwiper.isEnd) {
        this.isEnd = true;
      } else {
        this.isEnd = false;
      }
      if (this.mySwiper.isBeginning) {
        this.isBeginning = true;
      } else {
        this.isBeginning = false;
      }
    },
  },
};
